// Modules
import { useState } from "react";

// Components
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// Type Definitions
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import type { UploadChangeParam } from "antd/es/upload";

// Constants
import { CREATE_RETRO_CLAIM_FORM } from "constants/global";

type useFileUploadType = {
	handleUpload?: (url: string) => void;
	acceptFileTypes?: string;
};

export function useFileUpload({ handleUpload, acceptFileTypes }: useFileUploadType) {
	const [valid, setValid] = useState<boolean>(true);
	const [fileList, setFileList] = useState<UploadFile<any>[]>([]);

	const getBase64 = (img: RcFile, callback: (url: string) => void) => {
		const reader = new FileReader();
		reader.addEventListener("load", () => callback(reader.result as string));
		reader.readAsDataURL(img);
	};

	const beforeUpload = (file: RcFile) => {
		const isLt3M = file.size / 1024 / 1024 < 3;
		const uploadedFileType = `.${file.type?.substring(file.type.lastIndexOf("/") + 1)}`;
		const acceptFileTypeArray = acceptFileTypes?.split(",")?.map(function (item) {
			return item.trim();
		});
		const isAccepted = acceptFileTypeArray?.includes(uploadedFileType);

		if (!isLt3M || !isAccepted) {
			CountDownModal({
				timer: 3,
				title: !isAccepted ? CREATE_RETRO_CLAIM_FORM.ERROR_MESSAGE.FILE_TYPE_ERROR : CREATE_RETRO_CLAIM_FORM.ERROR_MESSAGE.IMAGE_MORE_SIZE,
				errorIcon: true
			});
			setValid(false);
		} else {
			setValid(true);
		}
		return isLt3M && isAccepted;
	};

	const handleChange: UploadProps["onChange"] = (info: UploadChangeParam<UploadFile>) => {
		valid ? setFileList(info.fileList) : setFileList([]);

		if (info.file.status !== "removed") {
			getBase64(info.file.originFileObj as RcFile, (url) => {
				handleUpload?.(url);
			});
		} else if (info.file.status === "removed") {
			handleUpload?.("");
		}
	};

	return { fileList, beforeUpload, handleChange };
}
